import FooterPrivacy from '../../../auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import { IReservesObject } from 'src/services/models/reserves.service';
import { IUser } from '../../../../utils/interfaces/user';
import Resume from 'src/views/pages/funding/reserves/monthlyActivity';
import Search from 'src/components/forms/reserves_search';
import Spinner from 'src/components/ui/spinner';
import Table from 'src/components/table/reservesTable';
import TableFooter from 'src/components/table/pagination/tableFooter';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    RESERVES_ACTIVITY_MESSAGE,
    RESERVES_MONTHLY_MESSAGE,
} from 'src/localization/resouceKeys';
import { useEffect, useState } from 'react';
import './styles.scss';

const loader = (
    <div className='loader_container'>
        <Spinner />
    </div>
);

export enum Tabs {
    MONTHLY = 'Monthly',
    ACTIVITY = 'Activity',
}

function isEmpty(obj: any) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }

    return true;
}

const FundingReserves = () => {
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const [brand, setBrand] = useState<string>('vw6');
    const [brandCode, setBrandCode] = useState<string>('');
    const [dealerID, setDealerID] = useState('');
    const [content, setContent] = useState<IReservesObject[]>([]);
    const [listContent, setListContent] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [tab, setTab] = useState(Tabs.MONTHLY);
    const [displayedContent, setDisplayedContent] = useState<IReservesObject[]>(
        [],
    );
    const [sortType, setSortType] = useState<string>('');
    const [sortOrder, setSortOrder] = useState<boolean>(false);
    const [currentMonth, setCurrentMonth] = useState<any>();
    const { reserves } = useLocalization();
    const { t } = useTranslation();

    const montharray = [
        reserves.FILTER_JANUARY,
        reserves.FILTER_FEBRUARY,
        reserves.FILTER_MARCH,
        reserves.FILTER_APRIL,
        reserves.FILTER_MAY,
        reserves.FILTER_JUNE,
        reserves.FILTER_JULY,
        reserves.FILTER_AUGUST,
        reserves.FILTER_SEPTEMBER,
        reserves.FILTER_OCTOBER,
        reserves.FILTER_NOVEMBER,
        reserves.FILTER_DECEMBER,
    ];

    useEffect(() => {
        if (currentDealers && dealerDataInfo) {
            const { dealer } = dealerDataInfo;
            setBrandCode('' + dealer.brandCode);
            setBrand(getBrandByDealerNumber(dealer.brand, dealer.dealerNumber));
            setDealerID(dealer.dealerNumber);
        }
    }, [dealerDataInfo]);

    useEffect(() => {
        if (content.length > Number('0')) {
            setLoading(false);
        }
    }, [content]);

    return !!dealerID ? (
        <>
            <div className='reserves-status-wrapper'>
                <div className='page-title'>
                    <h5>{reserves.TITLE}</h5>
                </div>
                <div className='reserves-search-container'>
                    <Search
                        content={content}
                        updateTableContent={setContent}
                        updateListContent={setListContent}
                        setCurrentMonth={setCurrentMonth}
                        dealerID={dealerID}
                        setLoading={setLoading}
                        sortType={sortType}
                        sortOrder={sortOrder}
                        isActivity={tab == Tabs.ACTIVITY ? true : false}
                        brandCode={brandCode}
                    />
                </div>
                <div className={'content-container'}>
                    <div className='c-tabs'>
                        <div className='c-tabs__nav-container'>
                            <nav aria-label='Tabs Navigation'>
                                <div className='c-tabs__nav'>
                                    <div className='c-tabs__nav-item'>
                                        <button
                                            className={`c-tabs__nav-link ${
                                                tab == Tabs.MONTHLY
                                                    ? 'is-active'
                                                    : ''
                                            }`}
                                            onClick={() => {
                                                setTab(Tabs.MONTHLY);
                                            }}
                                            type='button'
                                        >
                                            <a
                                                className='c-link'
                                                data-testid='link-item-faqs'
                                            >
                                                <span className='c-link__body'>
                                                    {reserves.TABS_MONTHLY}
                                                </span>
                                            </a>
                                        </button>
                                    </div>
                                    <div className='c-tabs__nav-item'>
                                        <button
                                            className={`c-tabs__nav-link ${
                                                tab == Tabs.ACTIVITY
                                                    ? 'is-active'
                                                    : ''
                                            }`}
                                            onClick={() => {
                                                setTab(Tabs.ACTIVITY);
                                            }}
                                            type='button'
                                        >
                                            <a
                                                className='c-link'
                                                data-testid='link-item-message-center'
                                            >
                                                <span className='c-link__body'>
                                                    {reserves.TABS_ACTIVITY}
                                                </span>
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                    <div className='table-title'>
                        <p className='table-title-strong add-margin'>
                            {tab == Tabs.ACTIVITY
                                ? reserves.ACTIVITY_HEADER
                                : `${reserves.MONTHLY_HEADER}
                            ${
                                content?.length > Number('0')
                                    ? ` ${reserves.MONTHLY_FOR} ${
                                          currentMonth?.month < Number('9')
                                              ? '0' +
                                                (currentMonth?.month +
                                                    Number('1'))
                                              : currentMonth?.month +
                                                Number('1')
                                      }-${currentMonth?.year}`
                                    : ''
                            }`}
                        </p>
                        {content?.length > Number('0') && !loading ? (
                            <div className='add-margin'>
                                <p>
                                    {tab == Tabs.ACTIVITY
                                        ? t(RESERVES_ACTIVITY_MESSAGE, {
                                              results: content.length,
                                          })
                                        : t(RESERVES_MONTHLY_MESSAGE, {
                                              month: `${
                                                  montharray[
                                                      currentMonth?.month
                                                  ]
                                              } ${currentMonth?.year}`,
                                              results: content.length,
                                          })}
                                </p>
                            </div>
                        ) : !loading ? (
                            <div className='empty-response'>
                                <span>{reserves.NO_RESUlTS}</span>
                            </div>
                        ) : null}
                        {loading ? (
                            loader
                        ) : content?.length > Number('0') ? (
                            <>
                                <Table
                                    items={displayedContent}
                                    sortType={sortType}
                                    sortOrder={sortOrder}
                                    setSortType={setSortType}
                                    setSortOrder={setSortOrder}
                                    isActivity={
                                        tab == Tabs.ACTIVITY ? true : false
                                    }
                                />
                                <TableFooter
                                    brand={brand}
                                    content={content}
                                    setDisplayedContent={setDisplayedContent}
                                />
                            </>
                        ) : null}
                        {tab == Tabs.MONTHLY &&
                        !isEmpty(listContent) &&
                        !loading ? (
                            <Resume
                                content={listContent}
                                date={`${montharray[currentMonth?.month]} ${
                                    currentMonth?.year
                                }`}
                            />
                        ) : null}
                    </div>
                </div>
                <div className='privacy-footer-container '>
                    <FooterPrivacy />
                </div>
            </div>
        </>
    ) : null;
};
export default FundingReserves;
